(function () {
  class MediaGalleryController {
    constructor(element) {
      this.element = element;
      this.viewer = element.querySelector('.media-viewer');
      this.items = Array.from(element.querySelectorAll('.media-viewer__item'));
      this.prevBtn = element.querySelector('.media-ctrl__btn[name="prev"]');
      this.nextBtn = element.querySelector('.media-ctrl__btn[name="next"]');
      this.counterCurrent = element.querySelector('.media-ctrl__current-item');
      this.counterTotal = element.querySelector('.media-ctrl__total-items');
      this.status = element.querySelector('.media-gallery__status');
      this.thumbnails = Array.from(element.querySelectorAll('.media-thumbs__item'));
      this.isMobile = window.innerWidth < 769;

      if (!this.viewer || this.items.length === 0) return;

      this.items.forEach((item, idx) => {
        item.dataset.index = idx + 1;
      });

      this.currentIndex = this.items.findIndex((item) => item.classList.contains('is-current-variant'));
      if (this.currentIndex < 0) this.currentIndex = 0;

      if (this.counterTotal) {
        this.counterTotal.textContent = this.items.length;
      }

      this.bindEvents();
      this.update();
      
      // Handle resize events
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 769;
      });
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(this.currentIndex - 1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goTo(this.currentIndex + 1);
        });
      }

      this.viewer.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.viewer.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      this.touchStartX = 0;

      this.thumbnails.forEach((thumb, index) => {
        const button = thumb.querySelector('button');
        if (!button) return;
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.goTo(index);
        });
      });
    }

    onTouchStart(event) {
      if (!event.touches || !event.touches.length) return;
      this.touchStartX = event.touches[0].clientX;
    }

    onTouchEnd(event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      const deltaX = event.changedTouches[0].clientX - this.touchStartX;
      if (Math.abs(deltaX) < 30) return;
      if (deltaX < 0) {
        this.goTo(this.currentIndex + 1);
      } else {
        this.goTo(this.currentIndex - 1);
      }
    }

    goTo(index) {
      const clampedIndex = Math.max(0, Math.min(index, this.items.length - 1));
      if (clampedIndex === this.currentIndex) return;
      this.currentIndex = clampedIndex;
      this.update();
    }

    update() {
      this.items.forEach((item, idx) => {
        const isActive = idx === this.currentIndex;
        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-current-variant', isActive);
        item.setAttribute('aria-hidden', (!isActive).toString());
        if (isActive) {
          this.loadMedia(item);
          this.playMedia(item);
        } else {
          this.pauseMedia(item);
        }
      });

      if (this.counterCurrent) {
        this.counterCurrent.textContent = this.currentIndex + 1;
      }
      if (this.prevBtn) {
        this.prevBtn.disabled = this.currentIndex === 0;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = this.currentIndex === this.items.length - 1;
      }
      this.updateThumbnails();
      this.updateStatus();
    }

    updateThumbnails() {
      if (!this.thumbnails.length) return;
      this.thumbnails.forEach((thumb, idx) => {
        const button = thumb.querySelector('button');
        const isActive = idx === this.currentIndex;
        thumb.classList.toggle('is-active', isActive);
        if (button) {
          if (isActive) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        }
      });
    }

    updateStatus() {
      if (!this.status) return;
      this.status.setAttribute('aria-hidden', 'false');
      this.status.textContent = window.accessibilityStrings?.imageAvailable
        ? window.accessibilityStrings.imageAvailable.replace('[index]', this.currentIndex + 1)
        : `Image ${this.currentIndex + 1} of ${this.items.length}`;
      window.setTimeout(() => {
        this.status.setAttribute('aria-hidden', 'true');
      }, 1500);
    }

    loadMedia(item) {
      item.querySelectorAll('[data-src]').forEach((node) => {
        if (!node.getAttribute('src')) {
          node.setAttribute('src', node.getAttribute('data-src'));
        }
        node.classList.remove('no-js-hidden');
      });
      item.querySelectorAll('[data-srcset]').forEach((node) => {
        if (!node.getAttribute('srcset')) {
          node.setAttribute('srcset', node.getAttribute('data-srcset'));
        }
        node.classList.remove('no-js-hidden');
      });
      item.querySelectorAll('.no-js-hidden').forEach((node) => node.classList.remove('no-js-hidden'));
    }

    playMedia(item) {
      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }
      const deferredMedia = item.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    pauseMedia(item) {
      const mediaElement = item.querySelector('video, model-viewer');
      if (mediaElement && typeof mediaElement.pause === 'function') {
        mediaElement.pause();
      }
    }
  }

  function initGalleries(root = document) {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (!gallery.__mediaGalleryController) {
        gallery.__mediaGalleryController = new MediaGalleryController(gallery);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initGalleries());
  document.addEventListener('shopify:section:load', (event) => initGalleries(event.target));
})();
